// External Imports
import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

// Internal Imports
import {
  languageCodeTagTaxonomyMap,
  languageCodeCategoryTaxonomyMap,
} from '../config/types/language.js';
import { CATEGORY_ARCHIVE } from '../config/types/path.js';
import { getPathMap } from './getPathMap.js';
import { getMatch } from './getMatch.js';
import { getEdition } from './getEdition.js';

// Local Functions
const getTaxonomy = ({ pathType }, currentEdition) => {
  if (pathType === CATEGORY_ARCHIVE) {
    return languageCodeCategoryTaxonomyMap[currentEdition];
  }
  return languageCodeTagTaxonomyMap[currentEdition];
};

const getTerm = createSelector(
  [getPathMap, getMatch, get('term'), getEdition],
  (pathMap, match, terms, currentEdition) => {
    const { slug } = match.params;
    const taxonomy = getTaxonomy(match, currentEdition);
    const id = get(`${taxonomy}.idBySlug.${slug}`, terms);
    const term = get(`${taxonomy}.byId.${id}`, terms);
    return term
      ? {
          ...term,
        }
      : false;
  },
);

// Module Exports
export { getTaxonomy, getTerm };
